//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            data: [
                {
                    rest: 'test rest',
                    contact: 'pepe',
                    email: 'pepe@pepe.com',
                    plan: 'basico',
                    nextInvoice: '20-20-20',
                    oweAmount: 10,
                    isActive: true,
                },
            ],
            columns: [
                {
                    name: 'restaurant',
                    label: 'Restaurante',
                    align: 'left',
                    field: 'rest',
                    sortable: true,
                },
                {
                    name: 'contact',
                    label: 'Contacto',
                    align: 'left',
                    field: 'contact',
                    sortable: true,
                },
                {
                    name: 'email',
                    label: 'Correo',
                    align: 'left',
                    field: 'email',
                    sortable: true,
                },
                {
                    name: 'plan',
                    label: 'Plan',
                    align: 'left',
                    field: 'plan',
                    sortable: true,
                },
                {
                    name: 'status',
                    label: 'Estatus',
                    align: 'left',
                    field: 'isActive',
                },
                {
                    name: 'nextInvoice',
                    label: 'Proxima facturacion',
                    align: 'left',
                    field: 'nextInvoice',
                    sortable: true,
                },
                {
                    name: 'oweAmount',
                    label: 'Monto adeudado',
                    align: 'left',
                    field: 'oweAmount',
                    sortable: true,
                },
            ],
        }
    },
}
